// import JS files
import '../kickstart';
import _ from 'lodash';
// import renderCasesMap from './case-map';
import renderRateMap from './rate-map';
import renderHospitalMap from './hospitals-map';
import './collapsible-table-rows';
import './new-deaths';
import './new-cases';
import './positive-rate';
import './new-tests';
import './daily-hospitalization';
// import './hospital-bed-usage';
// import './icu-beds';

function resize() {
  // code executed on window resize
  // renderCasesMap();
  renderRateMap();
  renderHospitalMap();
}

// call resize on load
resize();
window.addEventListener('resize', _.debounce(resize, 200));
